import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=71eec45c&scoped=true"
import script from "./VendorList.vue?vue&type=script&lang=js"
export * from "./VendorList.vue?vue&type=script&lang=js"
import style0 from "./VendorList.vue?vue&type=style&index=0&id=71eec45c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eec45c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71eec45c')) {
      api.createRecord('71eec45c', component.options)
    } else {
      api.reload('71eec45c', component.options)
    }
    module.hot.accept("./VendorList.vue?vue&type=template&id=71eec45c&scoped=true", function () {
      api.rerender('71eec45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/VendorList.vue"
export default component.exports